var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.version<5)?_c('oldApply'):_c('newApply')],1)}
var staticRenderFns = []

export { render, staticRenderFns }